import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { getRouteLayoutOptions } from '@/config/layout-routes';
import { useProfilesData } from '@/features/user/api';

import { DASHBOARD_COMPONENTS, getTemplate } from './index';

export const useBhanzuBuddyFeatures = () => {
  const { selectedCourse } = useProfilesData();
  const currentPathname = useLocation().pathname;

  const template = useMemo(
    () => getTemplate(selectedCourse?.product_name),
    [selectedCourse?.product_name]
  );

  const { dashboardComponents } = template;

  return useMemo(() => {
    const { hideBhanzuBuddy } = getRouteLayoutOptions(currentPathname);
    const isBuddyEnabledForCourse =
      dashboardComponents.includes(
        DASHBOARD_COMPONENTS.BHANZU_BUDDY_WITH_QUICK_CHALLENGE
      ) ||
      dashboardComponents.includes(
        DASHBOARD_COMPONENTS.BHANZU_BUDDY_WITHOUT_QUICK_CHALLENGE
      );

    return {
      showBhanzuBuddy: isBuddyEnabledForCourse && !hideBhanzuBuddy,
      enableQuickChallenge: dashboardComponents.includes(
        DASHBOARD_COMPONENTS.BHANZU_BUDDY_WITH_QUICK_CHALLENGE
      ),
    };
  }, [currentPathname, dashboardComponents]);
};
